module.exports = __webpack_public_path__ + "static/media/need-help-banner-mobile.2862e84b.webp";